import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as AdvertisementActions from './advertisement.actions';
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';

export const ADVERTISEMENT_FEATURE_KEY = 'advertisement';

export interface AdvertisementState
  extends EntityState<CasualTournamentEntity> {
  selectedId?: string | number;
  loaded: boolean;
  error?: string | null;
}

export interface AdvertisementPartialState {
  readonly [ADVERTISEMENT_FEATURE_KEY]: AdvertisementState;
}

export const advertisementAdapter: EntityAdapter<CasualTournamentEntity> =
  createEntityAdapter<CasualTournamentEntity>({
    selectId: (tournaments: CasualTournamentEntity) => tournaments.uuid,
  });

export const initialAdvertisementState: AdvertisementState =
  advertisementAdapter.getInitialState({
    // set initial required properties
    loaded: false,
  });

const reducer = createReducer(
  initialAdvertisementState,
  on(AdvertisementActions.loadAdvertisement, (state: AdvertisementState) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    AdvertisementActions.loadAdvertisementSuccess,
    (state, { advertisement }) => {
      return advertisementAdapter.setAll(advertisement, {
        ...state,
        loaded: true,
      });
    },
  ),
  on(AdvertisementActions.loadAdvertisementFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function advertisementReducer(
  state: AdvertisementState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
